import React from 'react';
import { take } from 'rxjs/operators';
import { HdWizardCurrentStep } from '../../wizard-native/hd-wizard';
import { HdWizardState, HdWizardStateWrapper } from '../../wizard-native/interface';

export function WizardSteps({
  wizardState,
  currentStep,
  LoadingComponent
}: {
  wizardState: HdWizardStateWrapper
  currentStep: HdWizardCurrentStep;
  LoadingComponent?: any;
}) {
  if (wizardState?.state === HdWizardState.LOADING_STEP && !!LoadingComponent) {
    return <LoadingComponent />;
  }

  if (!currentStep) {
    return null;
  }

  const Component = currentStep.component;
  const stepController = currentStep.controller;

  return (
    <Component
      initialData={stepController.trackedValue}
      onDataChange={(d) => { stepController.unsavedData = d; }}
      controller={stepController}
      back={stepController.goBack.bind(stepController)}
      completeStep={stepController.markAsComplete.bind(stepController)}
      skip={stepController.skipStep.bind(stepController)}
      markDirty={stepController.setDirty.bind(stepController)}
      setBeforeUnload={(callback) => {
        currentStep.beforeUnload = callback;
      }}
      closeWizard$={stepController.closeWizard.pipe(take(1)).toPromise()}
    />
    );
}
